/* eslint-disable prefer-arrow/prefer-arrow-functions */
import React from 'react';
import { EAsymmetryFlag } from '../../../data/providers/reports/asymmetryReportProvider';
import { Row } from '../../layout/Row';
import { EPdfMode } from '../../shared/pdf/Pdf';
import { ColorDot } from '../utils/ColorDot';
import { ASYMMETRY_COLORS } from './utils';

interface IProps {
  pdfMode?: EPdfMode;
}

export function AsymmetryLegend(props: IProps): React.ReactElement {
  return (
    <Row style={{ justifyContent: 'flex-end', gap: '1rem' }}>
      <Row style={{ flex: 0, alignItems: 'center', gap: '0.35rem' }}>
        <ColorDot
          color={ASYMMETRY_COLORS.baseline}
          borderColor={props.pdfMode === EPdfMode.PRINT ? 'black' : null}
          borderStyle={props.pdfMode === EPdfMode.PRINT ? 'dashed' : null}
        />
        <p>Baseline</p>
      </Row>
      <Row style={{ flex: 0, alignItems: 'center', gap: '0.35rem' }}>
        <ColorDot color={ASYMMETRY_COLORS[EAsymmetryFlag.NONE]} />
        <p>Good</p>
      </Row>
      <Row style={{ flex: 0, alignItems: 'center', gap: '0.35rem' }}>
        <ColorDot color={ASYMMETRY_COLORS[EAsymmetryFlag.WARN]} />
        <p>Warning</p>
      </Row>
      <Row style={{ flex: 0, alignItems: 'center', gap: '0.35rem' }}>
        <ColorDot color={ASYMMETRY_COLORS[EAsymmetryFlag.CRITICAL]} />
        <p>Critical</p>
      </Row>
    </Row>
  );
}
